export const HAS_BOUGHT_STORAGE_VALUE = '1'
